var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { class: { active: _vm.active }, attrs: { id: "sidebar-wrapper" } },
    [
      _c("div", { staticClass: "menuBlock" }, [
        _c("div", { staticClass: "menuBlock__top flex-between-center w-100" }, [
          _vm.shop
            ? _c(
                "a",
                {
                  attrs: { href: _vm.laCarte },
                  on: {
                    click: function ($event) {
                      _vm.UiService.isMobileView &&
                        _vm.UiService.toggleSidebar(false)
                    },
                  },
                },
                [
                  _c("h2", { staticClass: "sidebar-brand flex-start-center" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.shop.productTree.product.dn)),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("i", {
            staticClass:
              "fie-icon_close hover-color2 cursor-pointer p-20 line-height-1",
            on: {
              click: function ($event) {
                return _vm.UiService.toggleSidebar()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bgMenu", attrs: { id: "myGroup" } }, [
          _c(
            "ul",
            { ref: "simplebar", staticClass: "sidebar-nav h-100" },
            _vm._l(_vm.availableCategories, function (item, i) {
              return _c("sidebar-item", {
                key: i,
                attrs: { item: item, shop: _vm.shop },
              })
            }),
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }